module.exports = __webpack_public_path__ + "static/media/DigInnProjection.b86f6e4f.png";